// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"85":"b7fc5527758d53ad","144":"e004e4d88527e1d7","311":"435151100badf154","436":"1ea586d290186ca2","520":"ce3f5f6acc8080cb","684":"4a0cbaab84f33c44","952":"4aa0cf83de3e2f85"}[chunkId] + ".js";
};